var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showNewsFeed)?_c('swiper',{ref:"swiperRef",staticClass:"news-banner-slider",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.newsFeed),function(news){return _c('swiper-slide',{key:news.newsId},[_c('news-banner',{attrs:{"news":news},on:{"remove":_vm.remove}})],1)}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }